import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg2"
    version="1.1"
    viewBox="0 0 1026.197 1064.795"
    shapeRendering="geometricPrecision"
    {...props}
  >
    <g id="g10" transform="matrix(1.33333 0 0 -1.33333 0 1064.795)">
      <g id="g12">
        <g id="g14">
          <g id="g20">
            <g id="g22">
              <path
                id="path34"
                fill="#FFFFFF"
                stroke="#FFFFFF"
                strokeWidth="2"
                d="M53.844 399.298c0-182.8 148.182-330.98 330.975-330.98 7.414 0 14.769.239 22.055.72v.01h-.02c-89.205 12.93-147.086 42.6-184.146 78.78l-.01.01c-65.117 63.53-65.986 147.13-59.707 195.18 10.158 77.87 71.79 171.18 174.392 183.729 99.689 12.191 129.622-54.089 131.251-57.879-1.372 4.94-36.981 123.63-220.199 82.98-102.069-28.12-149.81-117.21-163.78-151.44.879 163.91 134.923 296.51 300.164 296.51 165.794 0 300.184-133.48 300.184-298.13 0-10.45-.543-20.77-1.6-30.93 5.579-3.461 16.734-10.671 28.442-19.89a333 333 0 0 1 3.959 51.33c0 182.799-148.191 330.98-330.985 330.98-182.793 0-330.975-148.181-330.975-330.98"
              ></path>
            </g>
          </g>
        </g>
      </g>
      <g id="g36">
        <g id="g38">
          <g id="g44">
            <g id="g46">
              <path
                id="path58"
                fill="#FFFFFF"
                stroke="#FFFFFF"
                strokeWidth="2"
                d="M337.383 526.747c-102.602-12.549-164.234-105.859-174.392-183.729-6.279-48.05-5.41-131.65 59.707-195.18l.01-.01c37.06-36.18 94.941-65.85 184.146-78.78h.02v-.01c126.413 8.32 233.447 87.61 281.613 198.4-19.329-26.57-45.708-53.91-81.208-75.48a349 349 0 0 0-14.709-8.381s-.01 0-.01-.009c-151.854-81.47-271.683 8.04-271.683 8.04-105.82 78.31-71.84 229.35 9.447 286.31 73.163 51.27 121.38 9.46 134.657-4.85.06-.06.119-.13.178-.19a35 35 0 0 0 3.09-3.58c.079-.1.148-.19.207-.26.03-.04.06-.08.079-.11.08-.1.128-.16.148-.2h.01s0 .02-.01.02c-.01.03-.03.07-.049.12-1.492 3.471-26.725 59.378-107.577 59.374-7.413 0-15.302-.471-23.674-1.495"
              ></path>
            </g>
          </g>
        </g>
      </g>
      <g id="g60">
        <g id="g62">
          <g id="g68">
            <g id="g70">
              <path
                id="path80"
                fill="#FFFFFF"
                stroke="#FFFFFF"
                strokeWidth="2"
                d="M613.907 364.683c-60.566-3.86-101.378-73.71-159.041-90.09 0 0-46.469-19.45-93.47 9.659-9.951 6.171-18.707 13.85-26.082 22.68 11.452-30.049 64.978-58.019 95.937-60.169 53.981-3.75 81.693 8.11 118.645 34.93s61.888 46.04 97.092 53.44c11.146 2.34 21.917 2.19 31.355.94 13.821-1.83 25.075-4.65 30.041-6.821-4.256 4.211-13.653 12.641-27.465 20.24-14.886 8.2-34.893 15.444-59.144 15.443-2.574 0-5.2-.082-7.868-.252"
              ></path>
            </g>
          </g>
        </g>
      </g>
      <g id="g82">
        <g id="g84">
          <g id="g90">
            <g id="g92">
              <path
                id="path102"
                fill="#FFFFFF"
                stroke="#FFFFFF"
                strokeWidth="2"
                d="M330.328 477.922c-81.287-56.96-115.268-207.999-9.447-286.309 0 0 119.828-89.51 271.683-8.04 0 .01.009.01.009.01 4.877 2.62 9.774 5.41 14.709 8.38 35.501 21.57 61.88 48.909 81.209 75.48.01.01.01.02.02.03 8.194 18.83 14.966 39.89 19.567 60.41.099.459.207.909.306 1.369-4.966 2.171-16.22 4.991-30.041 6.821-9.438 1.25-20.209 1.4-31.355-.94-35.204-7.4-60.141-26.62-97.092-53.44s-64.664-38.68-118.645-34.93c-30.959 2.15-84.485 30.12-95.937 60.169-12.518 14.94-21.127 33.151-25.007 52.751-6.86 34.61-4.007 84.72 51.859 121.23 47.366 27.99 87.724 7.56 102.819-7.841-8.515 9.176-31.391 29.66-66.003 29.659-19.365-.001-42.406-6.415-68.654-24.809"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SvgIcon; 